import QF_EXT_1 from "./QF_EXT_1";
export default {
  QF_EXT_1,
};
